export const EMPTY_FUNC = Object.freeze(() => null);
